<template>
    <FlyOut :visible="visible" :rightSide="rightSide" :fullscreen="is_fullscreen" :fullHeight="fullHeight" :columns="columns">
        <template #content>
            <PanelWidget class="f fv dw-10 dh-10">
                <template #content>
                    <header class="f fa-c sp-l-l sp-r-l sp-t-l">
                        <h2 v-if="uiTitle">
                            <span>{{ uiTitle }}</span>
                        </h2>
                        <span class="fg"></span>
                        <ButtonIcon v-if="allowFullscreen"
                            class="sm-r-s"
                            :icon="is_fullscreen ? 'contract' : 'expand'"
                            @click="onFullScreenToggle" />
                        <ButtonIcon icon="cross" @click="onClose" />
                    </header>
                    <div class="b-b sm-t-m fly-out-panel-divider"></div>
                    <div class="fg fly-out-panel-content sp-t-m sp-l-l sp-r-l sp-b-m" v-mead-scroll-fade-vertical :class="uiContentClass">
                        <slot name="content"></slot>
                    </div>
                    <div class="b-b sm-b-m fly-out-panel-divider"></div>
                    <footer class="f fh sp-l-l sp-r-l sp-b-l">
                        <slot name="footer"></slot>
                        <AthButton v-if="uiShowConfirm"
                            :lbl="uiConfirmLabel"
                            @click="onConfirm"
                            :disabled="uiConfirmDisabled"
                            class="fg el--s-s el--t-primary sm-r-m" />
                        <AthButton v-if="uiShowCancel"
                            :lbl="uiCancelLabel"
                            @click="onCancel"
                            :disabled="uiCancelDisabled"
                            class="fg el--s-s el--t-default" />
                    </footer>
                </template>
            </PanelWidget>
        </template>
    </FlyOut>
</template>

<script>
import AthButton from '../atoms/Button.vue';
import ButtonIcon from '../atoms/ButtonIcon.vue';
import UIMobileMixin from '../../mixins/UIMobile';
import PanelWidget from './PanelWidget.vue';
import FlyOut from './FlyOut.vue';

export default {
    name: 'mead-fly-out-panel',
    components: {PanelWidget, AthButton, ButtonIcon, FlyOut},
    mixins: [UIMobileMixin],
    props: {
        /**
         * Whether the fly-out panel is currently shown, passed straight through
         * to the underlying FlyOut component.
         */
        visible: {type: Boolean, default: false},
        /**
         * Title text displayed in the panel's header. Hidden entirely when empty.
         */
        uiTitle: {type: String, default: ''},
        /**
         * Label text for the confirm button in the panel's footer.
         */
        uiConfirmLabel: {type: String, default: ''},
        /**
         * Whether the confirm button is disabled.
         */
        uiConfirmDisabled: {type: Boolean, default: false},
        /**
         * Whether the confirm button is shown in the panel's footer.
         */
        uiShowConfirm: {type: Boolean, default: true},
        /**
         * Label text for the cancel button in the panel's footer.
         */
        uiCancelLabel: {type: String, default: ''},
        /**
         * Whether the cancel button is disabled.
         */
        uiCancelDisabled: {type: Boolean, default: false},
        /**
         * Whether the cancel button is shown in the panel's footer.
         */
        uiShowCancel: {type: Boolean, default: true},
        /**
         * Whether the panel slides in from the right side of the screen, passed
         * straight through to the underlying FlyOut component.
         */
        rightSide: {type: Boolean, default: true},
        /**
         * Additional CSS class(es) applied to the panel's scrollable content area.
         */
        uiContentClass: {type: String, default: ''},
        /**
         * Whether to show the header button that toggles the panel between its
         * normal size and fullscreen.
         */
        allowFullscreen: {type: Boolean, default: false},
        /**
         * Whether the panel stretches the full height of the screen, passed
         * straight through to the underlying FlyOut component.
         */
        fullHeight: {type: Boolean, default: false},
        /**
         * Width of the panel in grid columns (1-12) of the screen width, passed
         * straight through to the underlying FlyOut component. 0 keeps the
         * default fixed width.
         */
        columns: {type: Number, default: 0},
    },
    data: function () {
        return {
            is_fullscreen: false,
        }
    },
    methods: {
        onClose: function () {
            this.$emit('onClose');
        },
        onConfirm: function () {
            this.$emit('onConfirm');
        },
        onCancel: function () {
            this.$emit('onCancel');
        },
        onFullScreenToggle: function () {
            this.is_fullscreen = !this.is_fullscreen;
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../../sass/_variables.scss';

.fly-out-panel-divider {
    margin-left: -2rem;
    margin-right: -2rem;
}

.fly-out-panel-content {
    overflow: auto;
}
</style>
